import { PRODUCT_TO_CHARGE_ELEMENT, ProductKeyToHAMSMap } from './constants';
import type { Product } from './types';

export const getChargeElementTypeByProduct = (
	product: Product,
): { chargeElementPlural: string; chargeElementSingular: string } => {
	return {
		chargeElementSingular: PRODUCT_TO_CHARGE_ELEMENT[product],
		chargeElementPlural: PRODUCT_TO_CHARGE_ELEMENT[product] + 's',
	};
};

/**
 * When querying AGG for entitlements we need to pass through the `hamsProductKey` which is
 * a specific key used to identify the product, we're just mapping our product keys to those
 * hams keys for queries
 */

export const getHamsKey = (product: Product): string => {
	return ProductKeyToHAMSMap[product];
};

export const getProductNameFromProductKey = (product: Product): string => {
	switch (product) {
		case 'jira':
			return 'Jira';
		case 'jira-service-management':
			return 'Jira Service Management';
		case 'jira-product-discovery':
			return 'Jira Product Discovery';
		case 'confluence':
			return 'Confluence';
		default:
			return '';
	}
};
